import { useCallback, useEffect, useSyncExternalStore } from "react";

const KEY = "vaibot-theme";

function readTheme() {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === "light" || saved === "dark") return saved;
  } catch {
    /* ignore */
  }
  return "light";
}

// Single shared source of truth: every useTheme() caller (chat header,
// profile panel, …) reads and writes the same value, so toggling from one
// switch can never leave another holding a stale theme.
let current = readTheme();
const listeners = new Set();

function writeTheme(next) {
  current = next;
  try {
    localStorage.setItem(KEY, next);
  } catch {
    /* ignore */
  }
  document.documentElement.setAttribute("data-theme", next);
  listeners.forEach((notify) => notify());
}

export function useTheme() {
  const theme = useSyncExternalStore(
    (notify) => {
      listeners.add(notify);
      return () => {
        listeners.delete(notify);
      };
    },
    () => current
  );

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  const toggle = useCallback(
    () => writeTheme(theme === "dark" ? "light" : "dark"),
    [theme]
  );
  return { theme, toggle };
}
